import { LoadState } from "../../constants/enums";
import { IPromocode, IPromocodeState } from "./promocode.types";

export const initialPromocode: IPromocode = {
  rsa_promocode_uuid: null,
  promocode: "",
  deduction: 0,
  type: "FLAT",
  package_id: 0,
  package_uuid: null,
  package_name: null,
  package_price: 0,
  partner_id: 0,
  partner_uuid: null,
  partner_name: null,
  from_date: "",
  to_date: "",
  comment: "",
  status: "ACTIVE",
  is_agent_access: 1,
  company_outlet_uuid: null,
};

export const initialPromocodeState: IPromocodeState = {
  promocode: {
    list: {
      list: [],
      totalRecords: 0,
      loading: LoadState.NotLoaded,
      error: null,
    },
    data: {
      data: null,
      loading: LoadState.NotLoaded,
      error: null,
    },
  },
};
